export const leftRightContentPadding = 10;
